import { createContext, PropsWithChildren, useContext } from 'react';

import {
  useInView,
  type IntersectionOptions,
} from 'react-intersection-observer';

import { Box } from '@cast/design-system';
import type { BoxProps } from '@cast/design-system';

const InViewContext = createContext<boolean | undefined>(undefined);

type LazyLoadedBoxProps = PropsWithChildren<
  BoxProps & {
    rootMargin?: IntersectionOptions['rootMargin'];
  }
>;

export const LazyLoadedBox = ({
  children,
  rootMargin,
  ...props
}: LazyLoadedBoxProps) => {
  const { inView, ref } = useInView({ triggerOnce: true, rootMargin });

  return (
    <Box ref={ref} {...props}>
      <InViewContext.Provider value={inView}>{children}</InViewContext.Provider>
    </Box>
  );
};

export const useInViewport = () => {
  const isVisible = useContext(InViewContext);

  if (typeof isVisible === 'boolean') {
    return isVisible;
  }

  return true;
};
